<template>
  <v-row>
    <v-col
      v-for="system in siteSystemsList"
      :key="system.siteSystemId"
      cols="auto"
    >
      <SiteSystemCard :siteSystem="system" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

import { searchByTermFactory } from '@/Core.Patterns/Factory';
import { sortAlphabetically } from '@/Core.Patterns/Strategy';

import SiteSystemCard from '@/Core.Service.Domain/Sites/SiteSystems/Components/SiteSystemCard.vue';

import type { ISiteSystem } from '@/Core.Service.Domain/Sites/SiteSystems/types/index.ts';

const store = useStore();

const searchTerm = computed<string>(
  () => store.getters['SitesStore/SiteSystemsStore/siteSystemSearchTerm']
);
const allSiteSystems = computed<ISiteSystem[]>(
  () => store.getters['SitesStore/SiteSystemsStore/siteSystems']
);

const siteSystemsList = computed<ISiteSystem[]>(() => {
  const source = searchTerm.value
    ? (searchByTermFactory(searchTerm.value, ['siteSystemName'], allSiteSystems.value) as ISiteSystem[])
    : allSiteSystems.value;
  return sortAlphabetically(source) as ISiteSystem[];
});
</script>

<style lang="scss" scoped>
.v-col {
  flex-grow: 0;
}
</style>
